import React from "react"
import { Popover } from "antd"

export default {
    tableStatus(audit, vname, time, detail, status, type) {
        // console.log(audit, vname, time, detail, status, type === 1 ? '队' : '二');
        return (
            <div>
                {/* <div>审核状态：{audit}</div>
                    <div>审核员：{vname} </div>
                    <div>审核时间：{time}</div>
                    <div>审核详情{detail}</div> */}
                <div>
                    {
                        type === 1 ?
                            <div>
                                {
                                    (audit === '1' || audit === '2') && <span>{vname || ' - '}</span>
                                }
                                <div>
                                    {audit === '1' && <span>已通过</span>}
                                    {audit === '0' && <span>未审核</span>}
                                    {audit === '2' && <span>不通过</span>}
                                </div>
                            </div>
                            :
                            null
                    }

                    {
                        type === 2 ?
                            <div>
                                {/* <div>
                                    audit：{audit}===status：{status}===vname：{vname}
                                </div> */}
                                <div>
                                    {audit === '1' && status === '1' && <span>{vname || ' - '}</span>}
                                    {audit === '2' && status === '2' && <span>{vname || ' - '}</span>}
                                    {audit === '0' && status === '2' && <span>-</span>}
                                </div>
                                <div>
                                    {audit === '0' && status === '0' && <span>未审核</span>}
                                    {audit === '0' && status === '1' && <span>-</span>}
                                    {audit === '0' && status === '2' && <span>-</span>}
                                    {audit === '1' && status === '1' && <span>已通过</span>}
                                    {audit === '2' && status === '2' && <span>不通过</span>}
                                </div>
                            </div>
                            :
                            null
                    }
                    {
                        audit === '2' && type === 1 ? (
                            <Popover content={<div style={{ maxWidth: 200, wordBreak: 'break-all' }}>{detail || '无记录'}</div>} title={<div style={{ textAlign: 'center' }}>不通过原因</div>}>
                                <span style={{ color: '#1890ff', marginLeft: 10, cursor: 'pointer' }}>查看原因</span>
                            </Popover>
                        ) : null
                    }
                    {
                        (audit === '2' && status === '2') && type === 2 ? (
                            <Popover content={<div style={{ maxWidth: 200, wordBreak: 'break-all' }}>{detail || '无记录'}</div>} title={<div style={{ textAlign: 'center' }}>不通过原因</div>}>
                                <span style={{ color: '#1890ff', marginLeft: 10, cursor: 'pointer' }}>查看原因</span>
                            </Popover>
                        ) : null
                    }
                </div>
                {
                    type === 1 && audit !== '0' ?
                        <div>
                            <span>{time || ' - '}</span>
                        </div>
                        :
                        null
                }
                {
                    type === 2 && audit !== '0' ?
                        <div>
                            {audit === '1' && status === '1' && <span>{time || ' - '}</span>}
                            {audit === '2' && status === '2' && <span>{time || ' - '}</span>}
                        </div>
                        :
                        null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/routes/review/common2.js